/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ApplyCSS from '../../../../../components/ApplyCSS';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import commonUtil from '../../../../../utils/commonUtil';

import * as createAccountActions from '../../../../../pages/Accounts/createAccount/actions';

@connect(store => ({
  user: store.user.data,
  eventDetails: store.eventDetail.data,
  cartCountData: store.cartCountData.data,
}),
{ ...createAccountActions })

class HeaderLPWAP extends Component {
  redirectToLoginPageOnUserIconClick = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    const redirectBackUrl = window.location.origin;
    window.location.replace(
      `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`,
    );
  }
  render() {
    this.cartCount = 0;
    if (this.props.cartCountData && this.props.cartCountData.cartDetails && this.props.cartCountData.cartDetails.length > 0) {
      this.props.cartCountData.cartDetails.map(data => this.cartCount += parseInt(data.quantity, 10));
    }
    const isUserLoggedIn = !(this.props.user && this.props.user.result && this.props.user.result.emailId);
    return (
      <React.Fragment>
        <ApplyCSS pageName="headerLP" />
        <div className="container">
          <div className="mainRow row">
            <div className="col-xs-12 mainHeader giftMenuMobile">
              <div className="col-xs-2 returnIcon" onClick={(e) => { this.props.returnClickHandler(e); }}>
                <span className="icon-flecha_header_izquierda" />
              </div>
              <div className="col-xs-7 logoContainer--wap">
                <a href={serverClientUtil.getLPFullURL() + '/home'}>
                  <img src={commonUtil.getAssetURL() + '/images/liverpool-logo.svg'} alt="Liverpool - Es parte de mi vida" title="Liverpool - es parte de mi vida" /></a>
              </div>
              <div className="col-xs-3 bagWrapper">
                {isUserLoggedIn ? <a onClick={this.redirectToLoginPageOnUserIconClick}><span className="icon-iconos-perfil icon_icons_perfil_position_one" /> </a> : null}
                <a className="bolsita" href={serverClientUtil.getLPFullURL() + '/cart'}>

                  {this.cartCount >= 0 ? <React.Fragment>
                    <img src="https://assets.liverpool.com.mx/assets/images/iconos/bolsita.png" /><div className="cart-bubble">{this.cartCount}</div> </React.Fragment> :
          null
                  }
                </a>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default HeaderLPWAP;

